import { api } from './client.js';

/** 원본 randombox/product/prize_zaiko_dashboard.php */
export interface ZaikoRow {
  prizeCode: string;
  barcode: string | null;
  grade: string | null;
  productName: string | null;
  quantity: number;
  goodsIdx: string | null;
  gname: string | null;
  simg1: string | null;
  opname: string | null;
  leftsL: number | null;
  leftsF: number | null;
  soldoutAt: string | null;
  account: number | null;
  isopen: string | null;
  isshow: string | null;
  sold: number;
}

export interface ZaikoResult {
  randomboxId: string;
  name: string | null;
  from: string;
  to: string;
  rows: ZaikoRow[];
}

export const zaikoApi = {
  load: (randomboxId: string, from: string, to: string) =>
    api.get<ZaikoResult>(`/randombox/zaiko/${encodeURIComponent(randomboxId)}?from=${from}&to=${to}`),
};
